import(/* webpackMode: "eager" */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Breadcrumb.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Card.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/src/components/Breadcrumb/Breadcrumb.module.scss");
;
import(/* webpackMode: "eager" */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/src/app/contact/contact.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/seminee-sibiu/_work/pefoc-hydra/pefoc-hydra/src/components/Contact/Contact.tsx");
